<template>
  <div>
    <!-- HEADING -->
    <section class="mb-5">
      <div class="container text-center">
        <div class="col-lg-10 mx-auto">
          <h2 class="font-size-medium font-weight-bold mb-4">Biblioteca</h2>
        </div>
      </div>
    </section> <!-- HEADING -->

    <!-- FILTERS -->
    <section class="mb-5">
      <div class="container text-center d-flex flex-column flex-md-row justify-content-center align-items-center">
        <div class="mr-md-3 mb-3 mb-md-0">
          <template v-if="genres === 'loading'">
            <Loader
              color="color2"
              size="small"
            />
          </template>
          <template
            v-else-if="genres.length > 0"
          >
            <Select2
              class="genreSelect"
              :options="genresAvailable"
              @input="changeGenre"
              placeholder="Filtre por um gênero"
            />
          </template>
        </div>
        <div class="typeSelect mr-md-3 mb-3 mb-md-0">
          <DropdownSelect
            v-model.trim="filters.type"
            @change="reset"
            :options="bookTypesOptions"
            size="xSmall"
          />
        </div>
        <!-- <div class="paidSelect mr-md-3 mb-3 mb-md-0">
          <DropdownSelect
            v-model.trim="filters.paid"
            @change="reset"
            :options="paidOptions"
            size="xSmall"
          />
        </div> -->
        <div class="sortingSelect">
          <DropdownSelect
            v-model.trim="sort"
            @change="reset"
            :options="sortingOptions"
            size="xSmall"
          />
        </div>
      </div>
    </section> <!-- END FILTERS -->

    <!-- BOOKS -->
    <section>
      <div class="container">
        <div v-if="books.length > 0">
          <BookThumbList
            :books="books"
          />
          <div class="mt-3 text-center">
            <Button
              class="btn-outline-color2 btn-lg"
              :loading="loader"
              @click="loadMore"
              v-if="isLoadMoreVisible"
            >
              Carregar mais
            </Button>
          </div>
        </div>
        <Loader
          color="color2"
          size="big"
          v-else-if="loader"
        />
        <div v-else>
          <p class="text-center">Não foram encontrados livros com esses filtros</p>
        </div>
      </div>
    </section> <!-- END BOOKS -->
  </div>
</template>

<script>

import BooksService from '@/modules/books/services/books-service'
import GenresService from '@/modules/genres/services/genres-service'

import Button from '@/components/common/Button/Button'
import BookThumbList from '@/components/books/BookThumbList'
import DropdownSelect from '@/components/common/Select/DropdownSelect'
import Loader from '@/components/common/Loader/Loader'
import Select2 from '@/components/common/Select/Select2'

export default {
  components: {
    Button,
    BookThumbList,
    DropdownSelect,
    Loader,
    Select2
  },
  data () {
    return {
      genres: [],
      books: [],
      loader: false,
      page: 1,
      isLoadMoreVisible: true,
      filters: {
        type: 'users',
        genre: null,
        paid: 'all'
      },
      sort: 'DESC',
      sortingOptions: [
        {
          key: 'ASC',
          value: 'Mais antigos primeiro'
        },
        {
          key: 'DESC',
          value: 'Mais recentes primeiro'
        },
        {
          key: 'views',
          value: 'Mais lidos'
        }
      ],
      paidOptions: [
        {
          key: 'all',
          value: 'Livros pagos e gratuitos'
        },
        {
          key: 'paid',
          value: 'Livros pagos'
        },
        {
          key: 'free',
          value: 'Livros gratuitos'
        }
      ],
      bookTypesOptions: [
        {
          key: 'public_domain',
          value: 'Livros de domínio público'
        },
        {
          key: 'users',
          value: 'Livros de usuários'
        },
        {
          key: 'pro',
          value: 'Livros de usuários Pro'
        },
        {
          key: 'all',
          value: 'Todos os livros'
        }
      ]
    }
  },
  metaInfo: {
    title: 'Livros'
  },
  created () {
    // On page load, check if there is parameter of type allowed on this page and set it in case it is true
    const queryString = window.location.search
    const urlParams = new URLSearchParams(queryString)
    const type = urlParams.get('type')
    const paid = urlParams.get('paid')
    if (type) {
      const index = this.bookTypesOptions.findIndex(item => {
        return type === item.key
      })
      if (index >= 0) this.filters.type = type
    }
    if (paid) {
      const index = this.paidOptions.findIndex(item => {
        return paid === item.key
      })
      if (index >= 0) this.filters.paid = paid
    }

    this.getGenres()
    this.getBooks()
  },
  computed: {
    genresAvailable () {
      if (!Array.isArray(this.genres)) return []
      // const genres = this.genres.filter(genre => {
      //   return !this.book.genres.includes(genre.id)
      // })
      const genres = [...this.genres]

      genres.sort((a, b) => a.name.localeCompare(b.name))

      return genres.filter(genre => {
        return genre.count > 0
      }).map(genre => {
        return {
          label: `${genre.name} (${genre.count})`,
          code: genre.id
        }
      })
    }
  },
  methods: {
    reset (getGenres = false) {
      this.page = 1
      this.isLoadMoreVisible = true
      this.books = []
      this.getBooks()
      if (getGenres) this.getGenres()
    },
    async getGenres () {
      try {
        this.genres = 'loading'

        const countBookAmount = this.filters.paid !== 'all' ? this.filters.paid : null

        const genres = await GenresService.getGenres({ countBookType: this.filters.type, countBookAmount: countBookAmount })
        this.genres = [...genres]
      } catch (error) {
        error.handleGlobally && error.handleGlobally()
      }
    },
    async getBooks () {
      this.loader = true
      try {
        // Get is public domain
        let isPublicDomain = null
        let isScrivPro = null
        if (this.filters.type === 'public_domain') isPublicDomain = true
        else if (this.filters.type === 'users') isPublicDomain = false
        else if (this.filters.type === 'pro') {
          isPublicDomain = false
          isScrivPro = true
        }

        // Get order by and sort
        const orderBy = this.sort === 'views' ? 'views' : null
        const sort = this.sort === 'views' ? 'DESC' : this.sort

        let isPaid = null
        if (this.filters.paid === 'paid') isPaid = true
        else if (this.filters.paid === 'free') isPaid = false

        const params = {
          page: this.page,
          sort: sort,
          orderBy: orderBy,
          isPublicDomain: isPublicDomain,
          genreId: this.filters.genre,
          isPaid: isPaid,
          isScrivPro: isScrivPro
        }
        const books = await BooksService.getBooks(params)
        this.books = [...this.books, ...books]
        if (books.length <= 0) this.isLoadMoreVisible = false
      } catch (error) {
        error.handleGlobally && error.handleGlobally()
      }
      this.loader = false
    },
    loadMore () {
      this.page++
      this.getBooks()
    },
    changeGenre (genre) {
      this.filters.genre = genre ? genre.code : null
      this.reset(false)
    }
  }
}
</script>

<style lang="scss" scoped>
.min-height-wrap {
  min-height: 56px;
}
.genreSelect {
  width: 200px;
}
.typeSelect, .sortingSelect, .paidSelect {
  ::v-deep {
    .select-wraper {
      min-height: 42px;
      display: flex !important;
    }
  }
}
</style>
